<template>
  <v-dialog
    v-model="$attrs.value"
    width="500"
  >
    <v-card id="adsDialogComponent">
      <v-card-title class="d-flex justify-space-between">
        <div class="title">
          <v-avatar
            size="40"
          >
            <v-icon
              outlined
              color="primary" >
              delete
            </v-icon>
          </v-avatar>
          {{ title }}
        </div>
        <v-btn
          icon
          @click="show = false"
          aria-label="close"
        >
          <v-icon>
            close
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        Are you sure you want to remove this presenter from the event?
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="$emit('confirm')"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ConfirmDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
  },
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  }
}
</script>
